import { render, staticRenderFns } from "./franchiseList.vue?vue&type=template&id=0122d3a0&"
import script from "./franchiseList.vue?vue&type=script&lang=js&"
export * from "./franchiseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports